/**
 * Route for `self-signup-form-for-affiliates-brandable`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { SelfSignupFormForAffiliatesBrandablePage } from "../features/self-signup-form-for-affiliates-brandable/SelfSignupFormForAffiliatesBrandablePage";

export const selfSignupFormForAffiliatesBrandableRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/self-signup-form-for-affiliates-brandable",
	component: SelfSignupFormForAffiliatesBrandablePage,
});

export default selfSignupFormForAffiliatesBrandableRoute;
